/**
 * @file
 * 中奖名单组件 mixin
 */
import throttle from 'lodash-es/throttle';
import basicMixin from '../../../assets/mixins/basic';

// const mockData = [
//   {
//     viewerName: '哈哈😃',
//   },
//   {
//     viewerName: '哈哈😃',
//   },
//   {
//     viewerName: '哈哈😃',
//   },
// ];

export default {
  mixins: [basicMixin],

  props: {
    // 抽奖SDK
    lotterySdk: {
      type: Object,
      default: null,
    },
    // 抽奖ID
    lotteryId: {
      type: String,
    },
    lotteryInfo: Object,
  },

  data() {
    return {
      // 当前页码
      pageNumber: 0,
      // 总页码
      totalPages: 1,
      // 中奖者分行列表
      winnerGroups: [],
      // 上次滚动scrollTop
      lastScrollTop: null,
      // 是否加载中
      isLoading: false,
      // 分组列表
      groupList: [],
      // 当前选中的分组
      currentGroupId: null,
    };
  },

  computed: {
    isGroup() {
      return this.lotteryInfo && this.lotteryInfo.lotteryRange === 'customGroup' && this.lotteryInfo.customGroupLotteryType === 'average';
    }
  },

  async mounted() {
    if (this.isGroup) {
      await this.getGroupList();
      this.getGroupDetail();
    } else {
      this.getWinnersList();
    }
  },

  methods: {
    async getGroupList() {
      const res = await this.lotterySdk.getLotteryResultGroup(this.lotteryId);
      this.groupList = res.data;
      if (this.groupList.length) {
        this.currentGroupId = this.groupList[0].id;
      }
    },

    async getGroupDetail(params = {}) {
      const pageNumber = params.pageNumber || this.pageNumber + 1;
      if (pageNumber > this.totalPages || this.isLoading || !this.currentGroupId) {
        return;
      }

      let data = null;
      this.isLoading = true;
      try {
        data = await this.lotterySdk.getLotteryGroupDetail({
          pageNumber,
          lotteryId: this.lotteryId,
          groupId: this.currentGroupId,
        });
      } catch (e) {
        console.warn(e);
      } finally {
        this.isLoading = false;
      }

      if (data) {
        this.pageNumber = data.pageNumber;
        this.totalPages = data.totalPages;
        this.winnerGroups = this.winnerGroups.concat(this.setArrGroup(data.contents));
        if (this.$refs.container) {
          // PC 端更新容器组件样式
          this.$refs.container.updateBorderStatus();
        }
      }
    },

    switchGroup(item) {
      this.currentGroupId = item.id;
      this.winnerGroups = [];
      this.pageNumber = 0;
      this.totalPages = 1;
      this.isLoading = false;
      this.getGroupDetail();
    },

    async getWinnersList(params = {}) {
      const pageNumber = params.pageNumber || this.pageNumber + 1;
      if (pageNumber > this.totalPages || this.isLoading) {
        return;
      }

      let data = null;
      this.isLoading = true;
      try {
        data = await this.lotterySdk.getWinnersList({
          pageNumber,
          lotteryId: this.lotteryId,
        });
      } catch (e) {
        console.warn(e);
      } finally {
        this.isLoading = false;
      }

      if (data) {
        this.pageNumber = data.pageNumber;
        this.totalPages = data.totalPages;
        this.winnerGroups = this.winnerGroups.concat(this.setArrGroup(data.contents));
        // this.winnerGroups = this.winnerGroups.concat(this.setArrGroup(mockData));
        if (this.$refs.container) {
          // PC 端更新容器组件样式
          this.$refs.container.updateBorderStatus();
        }
      }
    },

    // 将数组进一步整理成n个一组
    setArrGroup(arr = [], groupLen = 3) {
      const groups = [];
      arr.forEach((item, index) => {
        let group;
        if (groups.length > 0) {
          group = groups[groups.length - 1];
        } else {
          groups.push([]);
          group = groups[0];
        }
        if ((index + 1) % groupLen === 0) {
          group.push(item);
          if (index + 1 < arr.length) {
            groups.push([]);
          }
        } else {
          group.push(item);
        }
      });
      return groups;
    },

    onClickBack() {
      this.$emit('back');
    },

    onScroll: throttle(function(e) {
      const $el = e.target;
      // 下滑
      if (this.lastScrollTop &&
        $el.scrollTop - this.lastScrollTop > 0 &&
        $el.scrollHeight - $el.clientHeight - $el.scrollTop <= 100
      ) {
        if (this.isGroup) {
          this.getGroupDetail();
        } else {
          this.getWinnersList();
        }
      }
      this.lastScrollTop = $el.scrollTop;
    }, 500),
  },
};
